// extracted by mini-css-extract-plugin
module.exports = {"root":"ShortInfo_root__1ePHz","image":"ShortInfo_image__1-6TY","info":"ShortInfo_info__3M7Q4","description":"ShortInfo_description__3cNkS"};